import { GALLERY } from "@/data/content";
import { SectionHeading } from "./SectionHeading";

export const Gallery = () => (
  <section id="gallery" className="border-t border-white/5 bg-[#0a0a0a] py-24">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        kicker="Галерея"
        title="Реалізовані дороги та авто"
        subtitle="Перевірки автомобілів, дороги по Європі, доставка та передача авто клієнтам."
      />
      <div className="mt-14 grid grid-cols-2 gap-4 md:grid-cols-4">
        {GALLERY.map((g, i) => (
          <div
            key={i}
            data-testid={`gallery-item-${i}`}
            className={`group relative overflow-hidden rounded-md border border-white/10 ${
              i % 5 === 0 ? "col-span-2 row-span-2" : ""
            }`}
          >
            <img
              src={g.url}
              alt={g.alt}
              loading="lazy"
              className="h-full min-h-[160px] w-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 transition-opacity group-hover:opacity-100" />
            <span className="absolute bottom-3 left-3 text-sm font-medium text-white opacity-0 transition-opacity group-hover:opacity-100">
              {g.alt}
            </span>
          </div>
        ))}
      </div>
    </div>
  </section>
);
